import { render } from "./SystemAccount.vue?vue&type=template&id=52d38cf0"
import script from "./SystemAccount.vue?vue&type=script&lang=js"
export * from "./SystemAccount.vue?vue&type=script&lang=js"

import exportComponent from "/home/eigyo65user/mystep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__